<template>
	<div class="content_box">
	  <div class="title">
		<span class="left_shu"></span>
		历史热图
		<div class="screen_box">
		  <div class="screen_title">选择参数：</div>
		  <el-select v-model="value" placeholder="请选择" @change="choiceType">
			<el-option
			  v-for="item in options"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			>
			</el-option>
		  </el-select>
		  <div class="screen_title">选择日期：</div>
		  <el-date-picker
			v-model="value1"
			type="datetimerange"
			range-separator="至"
			start-placeholder="开始日期"
			end-placeholder="结束日期"
			value-format="yyyy-MM-dd HH:mm:ss"
			@change="choiceTime"
			:picker-options="pickerOptions"
		  >
		  </el-date-picker>
		  <div class="screen_title">切换设备：</div>
		  <el-select
			v-model="deviceType"
			placeholder="请选择"
		  >
			<el-option
			  v-for="item in deviceTypeList"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			>
			</el-option>
		  </el-select>
		</div>
	  </div>
	  <div class="operation">
		<!-- <a-button class="creatadd" type="primary" @click="addModal">
				  创建策略
			  </a-button> -->
		<!-- <div class="sinput">
				  <input type="text" placeholder="请输入策略名称查询" />
				  <img src="../../assets/image/37.png" />
			  </div> -->
		<!-- <div class="block">
				  <el-slider v-model="timeSection" range :marks="marks" :max="24" show-stops @change="section">
				  </el-slider>
			  </div> -->
	  </div>
	  <div class="Map_box">
		<baidu-map
		  :center="{ lng: 118.82956267730716, lat: 31.876923009327903 }"
		  :zoom="18"
		  :scroll-wheel-zoom="true"
		  style="width: 100%; height: 100%"
		>
		  <bml-heatmap
			v-if="visible"
			:data="points"
			:max="maxValue"
			:radius="6"
			:min="minValue"
			:gradient="heat"
		  ></bml-heatmap>
		</baidu-map>
	  </div>
	</div>
  </template>
  
  <script>
  import dayjs from "dayjs";
  import { BmlHeatmap } from "vue-baidu-map";
  export default {
	name: "HistoryMap",
	components: {
	  //注册
	  BmlHeatmap,
	},
	data() {
	  return {
		visible: true,
		markerPo: {},
		heat: {
		  0.3: "rgb(0, 255, 0)",
		  0.6: "rgb(255, 255, 0)",
		  0.9: "rgb(225, 75, 0)",
		},
		points: [
		  {
			lat: "31.87447954613149",
			lng: "118.81857107961423",
			count: "38.89",
		  },
		],
		maxValue: 10,
		minValue: 1,
		options: [
		  {
			value: 1,
			label: "空气温度",
		  },
		  {
			value: 2,
			label: "空气湿度",
		  },
		  {
			value: 3,
			label: "大气压强",
		  },
		  {
			value: 4,
			label: "光照强度",
		  },
		  {
			value: 5,
			label: "风向",
		  },
		  {
			value: 6,
			label: "风速",
		  },
		  {
			value: 7,
			label: "降雨量",
		  },
		  {
			value: 9,
			label: "PM 2.5",
		  },
		  {
			value: 10,
			label: "PM 10",
		  },
		  {
			value: 14,
			label: "臭氧",
		  },
		  {
			value: 15,
			label: "一氧化碳",
		  },
		  {
			value: 16,
			label: "二氧化硫",
		  },
		  {
			value: 17,
			label: "二氧化氮",
		  },
		],
		deviceTypeList: [
		  {
			value: 1,
			label: "车载",
		  },
		  {
			value: 2,
			label: "气象站",
		  },
		],
		deviceType: 1,
		value: 1,
		endDate: "",
		startDate: "",
		value1: "",
		pickerOptions: {
		  onPick: ({ maxDate, minDate }) => {
			this.selectDate = minDate.getTime();
			if (maxDate) {
			  this.selectDate = "";
			}
		  },
		  disabledDate: (time) => {
			//time.getTime()获取的是时间戳
			// 当前时间往前30天可选
			// return (
			// time.getTime() > Date.now() ||
			// time.getTime() < Date.now() - 30 * 24 * 60 * 60 * 1000
			// )
			// 只能选择30天的范围且不能大于当前日期
			if (this.selectDate !== "") {
			  const one = 29 * 24 * 3600 * 1000;
			  const minTime = this.selectDate - one;
			  const maxTime = this.selectDate + one;
			  if (maxTime > Date.now()) {
				return (
				  time.getTime() < minTime ||
				  time.getTime() >
					new Date(new Date().toLocaleDateString()).getTime()
				);
			  } else {
				return time.getTime() < minTime || time.getTime() > maxTime;
			  }
			} else {
			  return (
				time.getTime() >
				new Date(new Date().toLocaleDateString()).getTime()
			  );
			}
		  },
		},
		timeSection: [0, 24],
		marks: {
		  0: "00:00",
		  1: "01:00",
		  2: "02:00",
		  3: "03:00",
		  4: "04:00",
		  5: "05:00",
		  6: "06:00",
		  7: "07:00",
		  8: "08:00",
		  9: "09:00",
		  10: "10:00",
		  11: "11:00",
		  12: "12:00",
		  13: "13:00",
		  14: "14:00",
		  15: "15:00",
		  16: "16:00",
		  17: "17:00",
		  18: "18:00",
		  19: "19:00",
		  20: "20:00",
		  21: "21:00",
		  22: "22:00",
		  23: "23:00",
		  24: {
			style: {
			  width: "40px",
			},
			label: this.$createElement("span", "24:00"),
		  },
		},
	  };
	},
	mounted() {
	  const nowDate = new Date();
	  const date = {
		year: nowDate.getFullYear(),
		month: nowDate.getMonth() + 1,
		date: nowDate.getDate(),
	  };
	  const newmonth = date.month > 9 ? date.month : "0" + date.month;
	  const day = date.date > 9 ? date.date : "0" + date.date;
	  this.endDate = dayjs().format("YYYY-MM-DD")+ " 23:59";
	  this.startDate = dayjs().format("YYYY-MM-DD")+ " 00:00";
	//   this.getPoints(1);
	},
	methods: {
	  async getPoints(type) {
		this.points = [];
		let result = await this.request.post("/v1.0/car/getHeatData", {
		  type: type,
		  startDate: this.startDate,
		  endDate: this.endDate,
		  deviceType: this.deviceType,
		});
		this.points = result.data.dataList.map((item) => {
		  return {
			lng: parseFloat(item.lng) + 0.012,
			lat: parseFloat(item.lat) + 0.004,
			count: parseFloat(item.count),
		  };
		});
		this.$nextTick(() => {
		  this.visible = true;
		  this.$forceUpdate();
		});
		this.maxValue = parseFloat(result.data.maxValue);
		this.minValue = parseFloat(result.data.minValue);
	  },
	  choiceType(e) {
		console.log(e);
		this.getPoints(e);
	  },
	  choiceTime(e) {
		this.visible = false;
		var startTime, endTime;
		if (this.timeSection[0].toString().length == 1) {
		  startTime = "0" + this.timeSection[0] + ":00";
		} else {
		  if (this.timeSection[0] == 24) {
			startTime = "23:59";
		  } else {
			startTime = this.timeSection[0] + ":00";
		  }
		}
		if (this.timeSection[1].toString().length == 1) {
		  endTime = "0" + this.timeSection[1] + ":00";
		} else {
		  if (this.timeSection[1] == 24) {
			endTime = "23:59";
		  } else {
			endTime = this.timeSection[1] + ":00";
		  }
		}
		console.log(e[0]);
		this.startDate = e[0] + " " + startTime;
		this.endDate = e[1] + " " + endTime;
		this.getPoints(this.value);
	  },
	  section(e) {
		var startTime, endTime;
		if (e[0].toString().length == 1) {
		  startTime = "0" + e[0] + ":00";
		} else {
		  if (e[0] == 24) {
			startTime = "23:59";
		  } else {
			startTime = e[0] + ":00";
		  }
		}
		if (e[1].toString().length == 1) {
		  endTime = "0" + e[1] + ":00";
		} else {
		  if (e[1] == 24) {
			endTime = "23:59";
		  } else {
			endTime = e[1] + ":00";
		  }
		}
		console.log(startTime);
		this.startDate = this.startDate.slice(0, 10) + " " + startTime;
		this.endDate = this.endDate.slice(0, 10) + " " + endTime;
		this.getPoints(this.value);
	  },
	},
  };
  </script>
  
  <style scoped>
  @import url("../../assets/css/common.css");
  
  .Map_box {
	background-size: cover;
	-webkit-background-size: cover;
	-o-background-size: cover;
	background-position: center 0;
	height: 600px;
  }
  
  .screen_box {
	display: flex;
	width: 90%;
	float: right;
  }
  
  .screen_box .el-date-editor .el-range-separator {
	width: 20px;
  }
  
  .screen_title {
	font-size: 12px;
	color: #666;
	padding: 0 15px;
  }
  
  .operation {
	display: flex;
	background-color: #f6f6f6;
	padding: 15px 40px;
	margin-bottom: 20px;
  }
  
  .block {
	width: 99%;
  }
  
  .el-slider__marks div {
	width: 50px !important;
  }
  </style>
  